/* Davis Fault Finder - progressive enhancement only.
   Everything is readable and shoppable with JavaScript disabled. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.ffReady === 'true') return;
    root.dataset.ffReady = 'true';

    var family = root.dataset.ffFamily || '';
    var finder = root.querySelector('[data-ff-finder]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ff-item]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-ff-group]'));

    /* ---- click-to-load videos (keeps the page fast) ---- */
    root.addEventListener('click', function (e) {
      var holder = e.target.closest ? e.target.closest('[data-ff-video]') : null;
      if (holder) loadVideo(holder);
    });
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var holder = e.target.closest ? e.target.closest('[data-ff-video]') : null;
      if (holder) {
        e.preventDefault();
        loadVideo(holder);
      }
    });

    function loadVideo(holder) {
      var id = holder.getAttribute('data-ff-video');
      if (!id || holder.dataset.ffLoaded === 'true') return;
      holder.dataset.ffLoaded = 'true';
      var frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      frame.title = 'Davis Instruments video';
      frame.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      frame.allowFullscreen = true;
      holder.innerHTML = '';
      holder.removeAttribute('role');
      holder.removeAttribute('tabindex');
      holder.appendChild(frame);
      track('davis_fault_video_play', { video_id: id, family: family });
    }

    /* ---- open the item named in the URL hash ---- */
    function openFromHash() {
      if (!location.hash) return;
      var target = root.querySelector(location.hash.replace(/[^#\w-]/g, ''));
      if (target && target.hasAttribute('data-ff-item')) {
        target.open = true;
        target.scrollIntoView({ block: 'start' });
      }
    }
    window.addEventListener('hashchange', openFromHash);
    openFromHash();

    /* ---- report which fault the customer opened ---- */
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        var label = item.querySelector('.ff-item__symptom');
        track('davis_fault_open', {
          family: family,
          component: item.getAttribute('data-ff-comp') || '',
          symptom: label ? label.textContent.trim() : item.id
        });
      });
    });

    /* ---- the finder itself ---- */
    if (!finder) return;
    finder.hidden = false;

    var compSelect = finder.querySelector('[data-ff-component]');
    var sympSelect = finder.querySelector('[data-ff-symptom]');
    var resetBtn = finder.querySelector('[data-ff-reset]');
    var countEl = finder.querySelector('[data-ff-count]');
    /* Keep a master copy of the symptom options. Safari on iOS ignores the hidden
       attribute on <option> and still shows disabled ones, so the list is rebuilt
       from this master copy instead of being hidden in place. */
    var anyOption = sympSelect.querySelector('option:not([data-ff-comp])');
    var anyLabel = anyOption ? anyOption.textContent : '';
    var sympMaster = Array.prototype.slice.call(sympSelect.querySelectorAll('option[data-ff-comp]')).map(function (opt) {
      return { value: opt.value, label: opt.textContent, comp: opt.getAttribute('data-ff-comp') };
    });

    function rebuildSymptoms(comp, keep) {
      var kept = '';
      sympSelect.innerHTML = '';
      var blank = document.createElement('option');
      blank.value = '';
      blank.textContent = anyLabel;
      sympSelect.appendChild(blank);
      sympMaster.forEach(function (o) {
        if (comp && o.comp !== comp) return;
        var opt = document.createElement('option');
        opt.value = o.value;
        opt.textContent = o.label;
        opt.setAttribute('data-ff-comp', o.comp);
        sympSelect.appendChild(opt);
        if (o.value === keep) kept = keep;
      });
      sympSelect.value = kept;
      return kept;
    }

    finder.addEventListener('submit', function (e) {
      e.preventDefault();
    });

    function apply(scroll) {
      var comp = compSelect.value;
      var symp = sympSelect.value;
      var shown = 0;

      /* the symptom list only ever offers symptoms from the chosen component */
      if (sympSelect.getAttribute('data-ff-built-for') !== comp) {
        symp = rebuildSymptoms(comp, symp);
        sympSelect.setAttribute('data-ff-built-for', comp);
      }

      items.forEach(function (item) {
        var match = (!comp || item.getAttribute('data-ff-comp') === comp) && (!symp || item.id === symp);
        item.hidden = !match;
        if (match) shown++;
        if (symp && match) {
          item.open = true;
        } else if (symp) {
          item.open = false;
        }
      });

      groups.forEach(function (group) {
        var visible = group.querySelectorAll('[data-ff-item]:not([hidden])').length;
        group.hidden = visible === 0;
      });

      if (countEl) {
        if (!comp && !symp) {
          countEl.textContent = '';
        } else {
          countEl.textContent = shown === 1 ? 'Showing 1 matching fault.' : 'Showing ' + shown + ' matching faults.';
        }
      }

      if (scroll && symp) {
        var target = document.getElementById(symp);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      if (comp || symp) {
        track('davis_fault_finder_filter', { family: family, component: comp, symptom: symp, results: shown });
      }
    }

    compSelect.addEventListener('change', function () {
      apply(false);
    });
    sympSelect.addEventListener('change', function () {
      apply(true);
    });
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        compSelect.value = '';
        sympSelect.value = '';
        apply(false);
      });
    }
  }

  function track(name, payload) {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, payload);
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(Object.assign({ event: name }, payload));
      }
    } catch (e) {
      /* analytics must never break the page */
    }
  }

  function boot() {
    document.querySelectorAll('[data-ff-family]').forEach(function (root) {
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
